<template>
  <div v-if="reports">
    <popup-add-report ref="popupAddReport" />
    <vs-row vs-justify="space-between">
      <vs-col vs-w="6">
        <p>Reports are automatically sorted by category in sidebar.</p>
      </vs-col>
      <div>
        <vs-button
          ref="createButton"
          id="create-button"
          class="vs-con-loading__container"
          @click="onClickCreateNew"
          type="relief"
          vslor="primary"
          >Add report</vs-button
        >
      </div>
    </vs-row>

    <vs-row> </vs-row>

    <!-- table -->
    <div id="data-list-list-view" class="data-list-container">
      <!-- <h3>{{ activeVenue.name }}</h3> -->

      <vs-table
        ref="table"
        class="mt-8"
        max-items="100"
        v-model="selected"
        pagination
        search
        :data="reports"
        @selected="onClicked(selected)"
      >
        <div
          slot="header"
          class="flex flex-wrap-reverse items-center flex-grow justify-between"
        >
          <div
            class="flex flex-wrap-reverse items-center data-list-btn-container"
          >
            <!-- ADD NEW -->
          </div>

          <!-- ITEMS PER PAGE -->
        </div>

        <template slot="thead">
          <vs-th sort-key="">Menu title</vs-th>
          <vs-th sort-key="">Category</vs-th>
          <vs-th sort-key="">Enabled</vs-th>
          <vs-th>Actions</vs-th>
        </template>

        <template slot-scope="{ data }">
          <tbody>
            <vs-tr :data="tr" :key="tr.id" v-for="tr in data">
              <vs-td>
                <p class="product-category">
                  {{ tr.title }}
                </p>
              </vs-td>

              <vs-td>
                <p class="product-category">
                  {{ categoryMap[tr.category] }}
                </p>
              </vs-td>

              <vs-td>
                <p class="product-category">
                  <vs-chip :color="tr.active ? 'success' : 'danger'">
                    {{ tr.active | yesno }}
                  </vs-chip>
                </p>
              </vs-td>
              <vs-td>
                <feather-icon
                  icon="EditIcon"
                  svgClasses="w-5 h-5 hover:text-danger stroke-current"
                  class="ml-4"
                  @click.stop="onClicked(tr)"
                />
                <feather-icon
                  icon="TrashIcon"
                  svgClasses="w-5 h-5 hover:text-danger stroke-current"
                  class="ml-4"
                  @click.stop="confirmDelete(tr)"
                />
              </vs-td>
            </vs-tr>
          </tbody>
        </template>
      </vs-table>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import PopupAddReport from "./popupAddReport.vue";
export default {
  components: {
    PopupAddReport,
  },
  data() {
    return {
      selected: [],
      schema: null,
    };
  },
  methods: {
    async onClickCreateNew() {
      this.$refs.popupAddReport.show();
    },
    confirmDelete(schema) {
      this.schema = schema;
      this.popupOpen = false;
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Confirm`,
        text: `Delete this report permanently? There is no way to undo this`,
        accept: this.deleteSchema,
      });
    },
    async deleteSchema() {
      await this.$store.dispatch(
        "cockpitReports/deleteCockpitReport",
        this.schema.id
      );
      this.schema = null;
    },
    onClicked(report) {
      this.$refs.popupAddReport.show(report);
    },
  },
  computed: {
    ...mapGetters({
      reports: "cockpitReports/cockpitReports",
      categoryMap: "cockpitReports/categoryMap",
    }),

    isSmallerScreen() {
      return this.$store.state.windowWidth < 768;
    },
  },

  created() {},
};
</script>

<style lang="scss">
.status-category {
  display: flex;
  align-items: center;
}

.status-circle {
  width: 14px;
  height: 14px;
  min-width: 14px;
  min-height: 14px;
  margin-right: 5px;
}

#data-list-list-view {
  .vs-con-table {
    /*
      Below media-queries is fix for responsiveness of action buttons
      Note: If you change action buttons or layout of this page, Please remove below style
    */
    @media (max-width: 689px) {
      .vs-table--search {
        margin-left: 0;
        max-width: unset;
        width: 100%;

        .vs-table--search-input {
          width: 100%;
        }
      }
    }

    @media (max-width: 461px) {
      .items-per-page-handler {
        display: none;
      }
    }

    @media (max-width: 341px) {
      .data-list-btn-container {
        width: 100%;

        .dd-actions,
        .btn-add-new {
          width: 100%;
          margin-right: 0 !important;
        }
      }
    }

    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 20px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }
        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check {
        padding: 0 15px !important;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>
